import {
  ADD_LOADER,
  REMOVE_LOADER,
  GET_USER_PREVIOUS_ORDERS_REQUEST,
  GET_USER_ORDERS_REQUEST,
  GET_USER_ORDERS_SUCCESS,
  GET_USER_ORDERS_FAILURE,
  GET_REFERRAL_INFO_REQUEST,
  GET_REFERRAL_INFO_SUCCESS,
  GET_REFERRAL_INFO_FAILURE,
  FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST,
  FETCH_E_SIGN_DOCUMENT_SUMMARY_SUCCESS,
  FETCH_E_SIGN_DOCUMENT_SUMMARY_FAILURE,
  E_SIGN_ACCEPT_REQUEST,
  E_SIGN_ACCEPT_SUCCESS,
  E_SIGN_ACCEPT_FAILURE,
  REMOVE_DRIVER_ACCESS_REQUEST,
  REMOVE_DRIVER_ACCESS_SUCCESS,
  REMOVE_DRIVER_ACCESS_FAILURE,
} from './types';

export const action = (type) => (payload) => ({
  type,
  payload,
});

export const addLoader = action(ADD_LOADER);
export const removeLoader = action(REMOVE_LOADER);

export const getUserPreviousOrdersRequest = action(GET_USER_PREVIOUS_ORDERS_REQUEST);

export const getUserOrdersRequest = action(GET_USER_ORDERS_REQUEST);
export const getUserOrdersSuccess = action(GET_USER_ORDERS_SUCCESS);
export const getUserOrdersFailure = action(GET_USER_ORDERS_FAILURE);

export const getReferralInfoRequest = action(GET_REFERRAL_INFO_REQUEST);
export const getReferralInfoSuccess = action(GET_REFERRAL_INFO_SUCCESS);
export const getReferralInfoFailure = action(GET_REFERRAL_INFO_FAILURE);

export const fetchESignDocumentSummaryRequest = action(FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST);
export const fetchESignDocumentSummarySuccess = action(FETCH_E_SIGN_DOCUMENT_SUMMARY_SUCCESS);
export const fetchESignDocumentSummaryFailure = action(FETCH_E_SIGN_DOCUMENT_SUMMARY_FAILURE);

export const eSignAcceptRequest = action(E_SIGN_ACCEPT_REQUEST);
export const eSignAcceptSuccess = action(E_SIGN_ACCEPT_SUCCESS);
export const eSignAcceptFailure = action(E_SIGN_ACCEPT_FAILURE);

export const removeDriverAccessRequest = action(REMOVE_DRIVER_ACCESS_REQUEST);
export const removeDriverAccessSuccess = action(REMOVE_DRIVER_ACCESS_SUCCESS);
export const removeDriverAccessFailure = action(REMOVE_DRIVER_ACCESS_FAILURE);
